// Enum to define the number of retry attempts
export enum Make {
  NoRetry = 0,
  OneRetry = 1,
  TwoRetries = 2,
  ThreeRetries = 3,
}
